import { useAffix } from 'hooks/useAffix'
import { useIsMobile } from 'hooks/useIsMobile'
import React, { useEffect, useLayoutEffect, useRef } from 'react'
import styled from 'styled-components'

interface AffixProps {
  children: React.ReactNode
  containerRef: React.RefObject<HTMLDivElement>
  market?: string
  /** Scroll ile sticky (fixed) durumuna geçtiğinde tetiklenir; mobilde affix kapalı olduğu için genelde false kalır */
  onFixedChange?: (isFixed: boolean) => void
}

const AffixWrapper = styled.div<{ isFixed: boolean }>`
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'static')};
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: top 0.4s ease-out;
`

const Affix: React.FC<AffixProps> = ({ children, containerRef, market, onFixedChange }) => {
  const isMobile = useIsMobile()

  const [isFixed] = useAffix({ containerRef, enabled: !isMobile })

  useEffect(() => {
    onFixedChange?.(isFixed)
  }, [isFixed, onFixedChange])
  const placeholderRef = useRef<HTMLDivElement>(null)
  const wrapperRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const placeholder = placeholderRef.current
    const wrapper = wrapperRef.current
    if (!placeholder) return

    const syncPlaceholderHeight = () => {
      if (isFixed && wrapper) {
        placeholder.style.height = `${wrapper.getBoundingClientRect().height}px`
        return
      }
      placeholder.style.height = '0px'
    }

    syncPlaceholderHeight()

    if (!isFixed || !wrapper || typeof ResizeObserver === 'undefined') {
      return
    }

    const observer = new ResizeObserver(syncPlaceholderHeight)
    observer.observe(wrapper)
    return () => observer.disconnect()
  }, [isFixed])

  return (
    <>
      <div ref={placeholderRef} />
      <AffixWrapper data-state={isFixed ? 'fixed' : 'static'} ref={wrapperRef} isFixed={isFixed}>
        {children}
      </AffixWrapper>
    </>
  )
}

export default Affix
